import { CommandVersion } from "./command-library.types";
import { storeEvent } from "./data-collection";
import { noCommand, noIPM } from "./event-recording.types";
export function recordEvent(ipmId, command, name) {
    const id = typeof ipmId === "string" ? ipmId : noIPM;
    void storeEvent(id, command, CommandVersion[command], name);
}
export function recordGenericEvent(name) {
    void storeEvent(noIPM, noCommand, 0, name);
}
